import React, { useState, useEffect, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { hashHistory } from 'react-router';
import SkuFiltersAssignToProductHeader from './SkuFiltersAssignToProductHeader';
import { GlobalHeaderButtons } from '../../PageLayout/GlobalHeaderButtons'
import { modifyPageLayoutComponents } from '../../PageLayout';
import { loadingDialog_show } from "../../../actions";
import { AccessRights } from '../../../schemas/accessRightsModel';
import * as helpers from '../../../utilities/helpers';
import { getApiConfig } from "../../../utilities";
import templateContentHeader from './SkuFiltersAssignToProductContentHeader.rt';
import { toggleShowAssignFeature } from './SkuFiltersAssignToProductActions';

import footerTemplate from './SkuFiltersAssignToProductContentFooter.rt';

let abortablePromise = null;

const SkuFiltersAssignToProduct = (props) => {

    const [featureGroups, setFeatureGroups] = useState([]);
    const [selectedFeatureGroup, setSelectedFeatureGroup] = useState(props.location.query.featureGroup);
    const [features, setFeatures] = useState([]);
    const [skuFilterItems, setSkuFilterItems] = useState([]);

    useEffect(() => {
        props.loadingDialog_show(true, 'Loading...', 'Loading features groups, this will take just a moment.');
        // setSelectedFeatureGroup(props.location.query.featureGroup) 
        getGroups();
    }, []);

    useEffect(() => {
        getFeatures(selectedFeatureGroup);
    }, [selectedFeatureGroup])

    useEffect(()=>{
        getSkuFilterItems();
    },[props.showAssignFeature]);

    const getGroups = () => {
        const { AR, subscriptionsInfo } = props;
        const fabricatorId = props.asCustomer.data ? props.asCustomer.data.fabricatorId : AR.auth.fabricatorId;
        const { masterFabricatorId } = AR.auth;

        if (abortablePromise) {
            abortablePromise.abort();
            abortablePromise = null;
        }

        abortablePromise = getApiConfig('SkuFilters');
        abortablePromise.get(`/features-groups/${fabricatorId}/${masterFabricatorId}`)
            .then(data => {
                var foundItem = data.groups.find(x => x.groupName == selectedFeatureGroup);
                if (foundItem) {
                    foundItem.active = true;
                }
                setFeatureGroups(data)
                props.loadingDialog_show(false);
            });
    }

    const getSkuFilterItems = () => {
        if (abortablePromise) {
            abortablePromise.abort();
            abortablePromise = null;
        } 

        abortablePromise = getApiConfig('SkuFilters');
        const {filterGroupID} = props.location.query;
        abortablePromise.get(`/SkuFilterGroupValues/${filterGroupID}/0`)
            .then(data => {
                setSkuFilterItems(data)
            });
    }


    const getFeatures = (groupName) => {
        const { AR, subscriptionsInfo } = props;
        const fabricatorId = props.asCustomer.data ? props.asCustomer.data.fabricatorId : AR.auth.fabricatorId;
        const { masterFabricatorId } = AR.auth;

        let apiConfig = getApiConfig('SkuFilters');
        apiConfig.get(`/feature-group-features/${fabricatorId}/${masterFabricatorId}/${groupName}`)
            .then(data => {
                setFeatures(data);
                console.log(data);
            });
    }

    const changeFeatureGroup = (index, groupName) => {
        if (featureGroups) {
            var newItems = featureGroups.groups.map((x) => ({ ...x, active: false }))
            newItems[index].active = true;
            featureGroups.groups = newItems
            setFeatureGroups(featureGroups);
            setSelectedFeatureGroup(groupName)
        }

    }

    const getImageUrl = (url, enabled) => {
        return helpers.getFeatureGroupIconURL(url, enabled);
    };

    const loadFeatureGroups = () => {
        if (featureGroups.groups) {
            let list = featureGroups.groups.map((x, i) => {
                let mystyle = {
                    backgroundImage: "url('http://quotesflooring.com//content/views/dashboard/images/icons/pj-scope-icons/enabled/countertop.svg')",
                    backgroundSize: '60%',
                    backgroundPosition: 'center top 33%'
                };

                mystyle.backgroundImage = `url('${getImageUrl(x.customImageUrl, x.enabled)}')`;
                return <li onClick={() => changeFeatureGroup(i, x.groupName)} data-index="0" key={i} className={`assign-sidebar-list__item assign-sidebar-list__item${x.active ? "--active" : ""}`}><div className="assign-sidebar-list__item-image" style={mystyle}></div><span className="assign-sidebar-list__item-title">{x.groupName}</span></li>
            });

            return list
        }

        return null
    }

    const loadFeatures = () => {
        if (features) {
            let list = features.map((x, i) => {
                return <li className='sku-assign-feature-item' key={i}>
                    <div>
                        {/* <div className='sku-assign-oval-33'>
                    </div> */}
                        <svg className="ui-svg-checkbox__icon-circle" height="30" width="30" style={{ position: "static" }}>
                            <circle cx="15" cy="15" r="12.5" stroke="#979797" strokeWidth="3" fill="#ffffff"></circle>
                        </svg>
                        {x.checked ? <div class="ui-svg-checkbox__icon-checked-icon"></div> : null}
                        <img className='sku-assign-bitmap' src={x.imageUrl}></img>
                        <div className="sku-assign-sku">
                            {x.sku} hakuna matata
                        </div>
                    </div>

                </li>
            });

            return list
        }

        return null
    }

    return <div
        className="app-content-main app-content-wrapper2">
        <div className="app-content-main">
            <aside className="assign-sidebar" style={{ top: "155px" }}>
                <div className="assign-sidebar-search">
                    <input type="text" className="ui-input ui-input--gray3" placeholder="Search" value={props.groupsTerm}
                        onChange={() => alert("e => this.handleSearchInputChange(e.target.value)")} />
                </div>
                <ul className='assign-sidebar-list assign-sidebar-list--qt'>
                    {loadFeatureGroups()}
                </ul>
            </aside>
            <div className='assign-container'>
                <div className='pj-scope-content' >
                    <ul className='pj-scope-flex-container' style={{ padding: "70px 0 0 0" }}>
                        {loadFeatures()}
                    </ul>
                </div>
            </div>
        </div>
        {props.showAssignFeature ?
            <div class="ui-popup ui-popup--large">
                <div class="ui-popup-header">
                    <span class="ui-popup-header__text">Assign Filters</span>
                </div>
                <div class="ui-popup-body ui-popup-body--small">
                    <div class="assign-popup">
                        <div class="assign-popup-content">
                            <div class="add-stone-container">
                                <div class="add-stone-col-1">
                                    <div class="assign-popup-title">Selected Features</div>
                                    <div class="assign-popup-selected-stones">
                                        <ul class="assign-popup-selected-stones__list ui-list">
                                            <li class="assign-popup-selected-stones__list-item" rt-repeat="f in this.props.features"
                                                onClick="e => this.excludeFeature(e, f)"  >
                                                <div class="ui-svg-checkbox">
                                                    <div class="ui-svg-checkbox__icon">
                                                        <svg class="ui-svg-checkbox__icon-circle" height="30" width="30">
                                                            <circle cx="15" cy="15" r="12.5" stroke="#979797" strokeWidth="3" fill="#ffffff" />
                                                        </svg>
                                                        <div class="ui-svg-checkbox__icon-checked-icon" rt-if="!this.state.excludedFeatures[f.id]"></div>
                                                    </div>
                                                    <div class="ui-svg-checkbox__text"> </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="wrapper">
                                    <h2>Filter Categories</h2>
                                    <div class="add-stone-col-2">
                                        <ul class="add-stone-list">
                                            <li
                                                rt-repeat="g in this.props.allFilterGroups"
                                                onClick="e => this.selectGroup(e,g)">
                                                <span></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="wrapper">
                                    <h2>Assign Color Filter</h2>
                                    {/* <FilterGroupValuesList type="xxx" filterItems={this.state.filterValuesFromCurrentGroup.toJS()}
                                    handleFilterClick="{this.handleFilterClick}" containerClass="add-stone-col-3"></FilterGroupValuesList> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ui-popup-footer">
                    <button class="ui-button ui-button--blue" onClick={() => this.props.toggleShowAssignFeature()}>
                        <span class="ui-button-text ui-button--uppercase">Cancel</span>
                    </button>
                    <button class="ui-button ui-button--green" onClick="() => this.handleSave()">
                        <span class="ui-button-text ui-button--uppercase">Save</span>
                    </button>
                </div>
            </div> : null}
    </div>
        ;
}

const mapStateToProps = state => {
    return {
        AR: AccessRights.get(state),
        asCustomer: state.asCustomer,
        showAssignFeature: state.skuFiltersAssignToProduct.showAssignFeature
    }
};

const mapDispatchToProps = dispatch => ({
    getFilters: (page, term) => dispatch(getFilters(page, term)),
    enableFilterGroup: (filterGroupID, enable) => dispatch(enableFilterGroup(filterGroupID, enable)),
    expandFilterGroup: (filterGroupID) => dispatch(expandFilterGroup(filterGroupID)),
    updateExpandedFilterGroupProp: (propName, value) => dispatch(updateExpandedFilterGroupProp(propName, value)),
    filterGroupVisualStylePopup: (show, style) => dispatch(filterGroupVisualStylePopup(show, style)),
    errorBox_Show: config => dispatch(errorBox_Show(config)),
    setActiveFilterGroupIcon: icon => dispatch(setActiveFilterGroupIcon(icon)),
    saveFilterGroup: group => dispatch(saveFilterGroup(group)),
    toggleShowAssignFeature: () => dispatch(toggleShowAssignFeature()),
    cancelFilterGroupEdit: (id) => dispatch(cancelFilterGroupEdit(id)),
    messageBox_Show: (show, type, title, message, buttons) => dispatch(messageBox_Show(show, type, title, message, buttons)),
    deleteFilterGroup: filterGroupID => dispatch(deleteFilterGroup(filterGroupID)),
    loadingDialog_show: (show, title, text) => dispatch(loadingDialog_show(show, title, text)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

class Footer extends PureComponent {
    render = footerTemplate
}

export const SkuFiltersAssignToProductComponents = modifyPageLayoutComponents({
    pageHeader: connector(SkuFiltersAssignToProductHeader),
    contentHeader: connector(templateContentHeader),
    content: connector(SkuFiltersAssignToProduct),
    pageFooter: connector(Footer)
});